import React, { useState, useEffect } from 'react';
import { getRuns, getRun } from '../../services/measureSvc';
import { MetricItem } from '../../components';
import { bodyMetricsOnly, clothingMetricsOnly, commonMetrics, findMetric, metricsForUser } from '../../services/metricsSvc';

import './Profile.scss';
import withAuth from '../../higherOrderComponents/withAuth';
import { useMyProfile } from '../../hooks/useMyProfile';

const loadRuns = async () => {
  try {
    const response = await getRuns();
    return response.data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const loadRun = async (runId) => {
  try {
    const response = await getRun(runId);
    return response.data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const ProfilePage = () => {
  const {profile} = useMyProfile();
  const [displayMetrics, setDisplayMetrics] = useState([]);
  const [measurementData, setMeasurementData] = useState();
  const [measurements, setMeasurements] = useState([]);

  useEffect(() => {
    setDisplayMetrics(metricsForUser(profile ? profile.gender : -1));
  }, [profile]);

  useEffect(() => {
    if (displayMetrics.length) {
      const tmp = displayMetrics.map((m) => ({ ...m, value: findMetric(m.id, measurementData) }));
      setMeasurements(tmp.sort((a, b) => a.id.localeCompare(b.id)));
    }
  }, [displayMetrics, measurementData]);

  useEffect(() => {
    setTimeout(async () => {
      console.log('ProfilePage loaded');
      const runs = await loadRuns();
      if (runs && runs.length > 0) {
        runs.sort((a, b) => (a.id > b.id ? -1 : 1));
        const runId = runs[0].id;
        console.log('Load runID: ' + runId);
        const runDetails = await loadRun(runId);
        const measurements =
          runDetails && runDetails.run && runDetails.data && runDetails.data.length > 0
            ? runDetails.data[0].measurements
            : [];
        setMeasurementData(measurements);
      }
    });
  }, []);

  const common = () => commonMetrics(measurements).map((m) => <MetricItem key={m.id} description={m.name} value={m.value}></MetricItem>)
  const body = () => bodyMetricsOnly(measurements).map((m) => <MetricItem key={m.id} description={m.name} value={m.value}></MetricItem>)
  const clothing = () => clothingMetricsOnly(measurements).map((m) => <MetricItem key={m.id} description={m.name} value={m.value}></MetricItem>)

  return (
    <div className="main-panel">
      {measurements && common()}
      {measurements && <><h2>Body</h2>{body()}</>}
      {measurements && <><h2>Clothing</h2>{clothing()}</>}

    </div>
  );
};

export default withAuth(ProfilePage);
